import useSWR from "swr";

export const useFetchManLaboSurveyAnswersCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: manLaboSurveyAnswerCount, error, isLoading } = useSWR<number>(`manzokudo_labo/survey/answers/count/?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`)
  return { manLaboSurveyAnswerCount, isLoading, error };
};